/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import React, { useState } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { translateAuto } from "../../../../../../../_metronic/_helpers/AtHelper";
import { DropdownCustomToggler } from "../../../../../../../_metronic/_partials/dropdowns";
import { InvoiceForm } from "./InvoicePdf";
const adapter = new LocalStorage("db");
const db = low(adapter);
export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditProductPage, openDeleteProductDialog, openDetailProductPage }
) => {
  const UpdateBulling = ({ row }) => {
    const [showModalInvoice, setshowModalInvoice] = useState(false);
    const { t } = useTranslation();
    return (
      <>
        <li className="navi-item">
          <p
            className="navi-link mb-0"
            onClick={() => {
              setshowModalInvoice(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
              <i className="fas fa-file-invoice text-success"></i>
            </span>
            <span className="navi-text">{t("Print") + " " + t("invoice")}</span>
          </p>
        </li>
        <Modal
          size="xl"
          show={showModalInvoice}
          onHide={() => {
            setshowModalInvoice(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Invoice")}: {row.Code}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <InvoiceForm row={row} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setshowModalInvoice(false);
              }}
            >
              {"Close"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };
  return (
    <>
      <Dropdown className="dropdown-inline position-unset" alignRight>
        <Dropdown.Toggle as={DropdownCustomToggler} id="dropdown-toggle-top">
          <i className="ki ki-bold-more-hor" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
          <ul className="navi navi-hover py-5">
              <li className="navi-item">
                <a
                  className="navi-link"
                  onClick={() => openEditProductPage(row.id)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Write.svg"
                      )}
                    />
                  </span>

                  <span className="navi-text">{translateAuto("Edit")}</span>
                </a>
              </li>

            <li className="navi-item">
              <a
                className="navi-link"
                onClick={() => openDetailProductPage(row.id)}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")} />
                </span>
                <span className="navi-text">{translateAuto("Detail")}</span>
              </a>
            </li>
            <li className="navi-item">
              <a
                className="navi-link"
                style={
                  row.DraftReadonly
                    ? { pointerEvents: "none", opacity: "0.5" }
                    : { pointerEvents: "auto", Opacity: "1" }
                }
                onClick={() => {
                  if (row.DraftReadonly) {
                    return;
                  }
                  var myHeaders = new Headers();
                  myHeaders.append(
                    "Authorization",
                    `Bearer ${db.read().getState()?.Token}`
                  );
                  myHeaders.append("Content-Type", "application/json");
                  myHeaders.append("Accept", "text/plain");
                  fetch(`${window.$apiurl}/api/Shipments/PostUnpost`, {
                    method: "post",
                    headers: myHeaders,
                    body: JSON.stringify({
                      ShipmentId: row.id,
                      AsDraft: !row.IsDraft,
                    }),
                  })
                    .then(async (response) => {
                      const statusCode = await response.status;
                      const contentType = response.headers.get("content-type");
                      if (
                        contentType &&
                        contentType.indexOf("application/json") !== -1
                      ) {
                        return response
                          .json()
                          .then((data) => [statusCode, data]);
                      } else {
                        return response
                          .text()
                          .then((text) => [statusCode, { Message: "" }]);
                      }
                    })
                    .then((result) => {
                      if (result[0] === 200) {
                        document.getElementById("textRefrech").click();
                      } else {
                        if (
                          result[1].ModelState !== null &&
                          result[1].ModelState !== undefined &&
                          result[1].ModelState !== ""
                        ) {
                          let modelState = result[1].ModelState;
                          if (modelState)
                            Object.keys(modelState).forEach(function(k) {
                              modelState[k].forEach((element) => {
                                Swal.fire(translateAuto("Error"), translateAuto(element), "error");
                              });
                            });
                        } else if (
                          result[1].Message !== null &&
                          result[1].Message !== undefined &&
                          result[1].Message !== ""
                        ) {
                          Swal.fire(translateAuto("Error"), translateAuto(result[1].Message), "error");
                        } else if (
                          result[1].error_description !== null &&
                          result[1].error_description !== undefined &&
                          result[1].error_description !== ""
                        ) {
                          Swal.fire(translateAuto("Error"), translateAuto(result[1].error_description), "error");
                        } else {
                          Swal.fire(translateAuto("Error"), translateAuto("Bad_request"), "error");
                        }
                      }
                    })
                    .catch((error) => {
                      Swal.fire(translateAuto("Error"), translateAuto(error), "error");
                    });
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Devices/iPhone-X.svg")}
                  />
                </span>
                <span className="navi-text ">
                  {!row.DraftReadonly
                    ? row.IsDraft
                      ? translateAuto("Post_to_TaaP")
                      : translateAuto("Remove_from_TaaP")
                    : translateAuto("Remove_from_TaaP")}
                </span>
              </a>
            </li>
            {row.Status === "Open" || row.Status === "Draft" ? (
              <li className="navi-item">
                <a
                  className="navi-link"
                  onClick={() => openDeleteProductDialog(row.id)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                    />
                  </span>
                  <span className="navi-text">{translateAuto("Delete")}</span>
                </a>
              </li>
            ) : null}
            <li className="navi-item">
              {row.Status !== "Draft" &&
                row.Status !== "" &&
                row.Status !== undefined &&
                row.Status !== null && (
                  <Link
                    className="navi-link"
                    to={`/trackload/${row.id}/details`}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
                      <i className="fas fa-map text-info"></i>
                    </span>
                    <span className="navi-text">{translateAuto("Track_load")}</span>
                  </Link>
                )}
            </li>
              <UpdateBulling row={row} />
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
